module.exports = __webpack_public_path__ + "img/BuyAbilityImg1.46bbe7ba.png";